import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Components } from 'react-markdown'

// Maps raw-Markdown elements to the portal's existing Tailwind tokens.
// No typography plugin is installed, so classes are explicit here.
const components: Components = {
  h1: ({ node: _node, ...props }) => (
    <h1 className="mb-3 mt-8 text-2xl font-semibold tracking-tight first:mt-0" {...props} />
  ),
  h2: ({ node: _node, ...props }) => (
    <h2 className="mb-2 mt-8 text-lg font-semibold tracking-tight first:mt-0" {...props} />
  ),
  h3: ({ node: _node, ...props }) => (
    <h3 className="mb-2 mt-6 text-base font-semibold first:mt-0" {...props} />
  ),
  p: ({ node: _node, ...props }) => (
    <p className="my-3 leading-7 text-muted-foreground first:mt-0" {...props} />
  ),
  ul: ({ node: _node, ...props }) => (
    <ul className="my-3 list-disc space-y-1 pl-6" {...props} />
  ),
  ol: ({ node: _node, ...props }) => (
    <ol className="my-3 list-decimal space-y-1 pl-6" {...props} />
  ),
  li: ({ node: _node, ...props }) => (
    <li className="text-muted-foreground" {...props} />
  ),
  a: ({ node: _node, ...props }) => (
    <a className="font-medium text-primary underline underline-offset-2 hover:opacity-80" {...props} />
  ),
  blockquote: ({ node: _node, ...props }) => (
    <blockquote className="my-4 border-l-2 border-[var(--brand-mint)] pl-4 text-muted-foreground/80" {...props} />
  ),
  hr: ({ node: _node, ...props }) => (
    <hr className="my-6 border-border" {...props} />
  ),
  strong: ({ node: _node, ...props }) => (
    <strong className="font-semibold text-foreground" {...props} />
  ),
  em: ({ node: _node, ...props }) => (
    <em className="italic" {...props} />
  ),
  code: ({ node: _node, ...props }) => (
    <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[0.85em] text-foreground" {...props} />
  ),
  pre: ({ node: _node, ...props }) => (
    <pre className="my-4 overflow-x-auto rounded-xl border border-border bg-muted/50 p-4 text-sm leading-6" {...props} />
  ),
  table: ({ node: _node, ...props }) => (
    <div className="my-4 overflow-x-auto rounded-xl border border-border bg-card">
      <table className="w-full border-collapse text-left text-sm" {...props} />
    </div>
  ),
  thead: ({ node: _node, ...props }) => (
    <thead className="border-b border-border bg-muted/40" {...props} />
  ),
  th: ({ node: _node, ...props }) => (
    <th className="px-3 py-2 text-xs font-semibold text-foreground" {...props} />
  ),
  td: ({ node: _node, ...props }) => (
    <td className="px-3 py-2 align-top text-muted-foreground" {...props} />
  ),
}

export function MarkdownArticle({ content }: { content: string }) {
  return (
    <div className="text-sm">
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {content}
      </Markdown>
    </div>
  )
}